import {createGlobalStyle, css} from 'styled-components';

import TEEERegularEot from '../assets/fonts/TEEE-Regular.eot';
import TEEERegularWoff from '../assets/fonts/TEEE-Regular.woff';
import TEEERegularWoff2 from '../assets/fonts/TEEE-Regular.woff2';
import TEEERegularTtf from '../assets/fonts/TEEE-Regular.ttf';
import TEEEMediumEot from '../assets/fonts/TEEE-Medium.eot';
import TEEEMediumWoff from '../assets/fonts/TEEE-Medium.woff';
import TEEEMediumWoff2 from '../assets/fonts/TEEE-Medium.woff2';
import TEEEMediumTtf from '../assets/fonts/TEEE-Medium.ttf';
import TEEEBoldEot from '../assets/fonts/TEEE-Bold.eot';
import TEEEBoldWoff from '../assets/fonts/TEEE-Bold.woff';
import TEEEBoldWoff2 from '../assets/fonts/TEEE-Bold.woff2';
import TEEEBoldTtf from '../assets/fonts/TEEE-Bold.ttf';
import TEEELightEot from '../assets/fonts/TEEE-Light.eot';
import TEEELightWoff from '../assets/fonts/TEEE-Light.woff';
import TEEELightWoff2 from '../assets/fonts/TEEE-Light.woff2';
import TEEELightTtf from '../assets/fonts/TEEE-Light.ttf';
import TEEESemiLightEot from '../assets/fonts/TEEE-SemiLight.eot';
import TEEESemiLightWoff from '../assets/fonts/TEEE-SemiLight.woff';
import TEEESemiLightWoff2 from '../assets/fonts/TEEE-SemiLight.woff2';
import TEEESemiLightTtf from '../assets/fonts/TEEE-SemiLight.ttf';
export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'La Nord';
    src: url(${TEEERegularEot});
    src: url(${TEEERegularWoff2}) format('woff2'), url(${TEEERegularWoff}) format('woff'),
    url(${TEEERegularTtf}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'La Nord';
    src: url(${TEEEMediumEot});
    src: url(${TEEEMediumWoff2}) format('woff2'), url(${TEEEMediumWoff}) format('woff'),
    url(${TEEEMediumTtf}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'La Nord';
    src: url(${TEEEBoldEot});
    src: url(${TEEEBoldWoff2}) format('woff2'), url(${TEEEBoldWoff}) format('woff'),
    url(${TEEEBoldTtf}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'La Nord';
    src: url(${TEEELightEot});
    src: url(${TEEELightWoff2}) format('woff2'), url(${TEEELightWoff}) format('woff'),
    url(${TEEELightTtf}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'La Nord Semi';
    src: url(${TEEESemiLightEot});
    src: url(${TEEESemiLightWoff2}) format('woff2'), url(${TEEESemiLightWoff}) format('woff'),
    url(${TEEESemiLightTtf}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :focus {
    outline: none;
  }

  body {
    ${({theme}) => css`
      background: ${theme.white};
      color: ${theme.gray};
    `};
    -webkit-font-smoothing: antialiased;
  }

  body, input, textarea, button {
    font-family: 'La Nord', sans-serif;
    font-style: normal;
    font-weight: 400;
  }

  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  h1 {
    ${({theme}) => css`
      color: ${theme.accent};
    `};
  }
`;
